import React from 'react';

import { DeleteLogin } from 'components/DeleteLogin';
import { Login } from 'components/Login';
import { DeleteMe, PrivacyPolicy, SuperAdmin } from 'pages';

export interface IRoute {
    path: string;
    Element: React.ElementType;
}

const NotFound = () => <div>Not found</div>;

export const ROUTES: IRoute[] = [
    {
        path: '/',
        Element: Login,
    },
    {
        path: '/delete-login',
        Element: DeleteLogin,
    },
    {
        path: '/admin-panel',
        Element: SuperAdmin,
    },
    {
        path: '/privacy-policy',
        Element: PrivacyPolicy,
    },
    {
        path: '/delete-me',
        Element: DeleteMe,
    },
    {
        path: '*',
        Element: NotFound,
    },
];
